"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMoleculeWithH = getMoleculeWithH;
const ensureHeterotopicChiralBonds_js_1 = require("../diastereotopic/ensureHeterotopicChiralBonds.js");
/**
 * Expand all the implicit hydrogens and ensure chiral bonds on heterotopic bonds
 * @param molecule
 * @returns
 */
function getMoleculeWithH(molecule, options) {
    const { logger, maxNbAtoms } = options;
    const moleculeWithH = molecule.getCompactCopy();
    moleculeWithH.addImplicitHydrogens();
    if (moleculeWithH.getAllAtoms() > maxNbAtoms) {
        logger.warn(`too many atoms to evaluate heterotopic chiral bonds: ${moleculeWithH.getAllAtoms()} > ${maxNbAtoms}`);
    }
    else {
        (0, ensureHeterotopicChiralBonds_js_1.ensureHeterotopicChiralBonds)(moleculeWithH);
    }
    return moleculeWithH;
}
//# sourceMappingURL=getMoleculeWithH.js.map